import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cube",
  "use": "cube-usage",
  "viewBox": "0 0 26 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 28\" id=\"cube\"><path fill=\"currentColor\" d=\"M14 25.453L24 20v-9.938l-10 3.641v11.75zm-1-13.516l10.906-3.969L13 3.999 2.094 7.968zM26 8v12c0 .734-.406 1.406-1.047 1.75l-11 6c-.297.172-.625.25-.953.25s-.656-.078-.953-.25l-11-6A1.988 1.988 0 010 20V8c0-.844.531-1.594 1.313-1.875l11-4c.219-.078.453-.125.688-.125s.469.047.688.125l11 4A1.995 1.995 0 0126.002 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol